import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import BasicInfo from './BasicInfo.js';
import Barragem from './Barragem.js';
import CreatedBy from './CreatedBy.js';
import UploadPae from './UploadPae.js';
import Monitor from './Monitor.js';
import api from "../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const classes = useStyles();
    // declarando componente da snackbar
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        _id: '',
        area: '',
        altura: '',
        volume: '',
        tipo: 'a',
        namaxH: '',
        naminH: '',
        tvr: 'Sim',
        dano: 'Sim',
        projeto: '',
        paeb_pdf: '',
        cotaterra: '',
        restricao: '',
        e_monitor: '',
        comprimento: '',
        extravasor: 'a',
        cotaconcreto: '',
        onda: 'Imediata',
        status: 'Ativada',
        nivelResp: 'Verde',
        nivel_restricao: '',
        modificacaotvr: 'Sim',

        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    const [update, setUpdate] = useState(false) // true in edit mode
    useEffect(() => {
        if (props.data) {
            setValues(props.data)
            setUpdate(true)
        }
    }, [props])

    async function Update() {
        let x = values.nivelResp
        var update_usinasui = {
            "_id": values._id,
            'tvr': values.tvr,
            'tipo': values.tipo,
            'dano': values.dano,
            'onda': values.onda,
            'status': values.status,
            'nivelResp': values.nivelResp,
            'nivelRespC': x === 'Verde' ? '#adcd98' : x === 'Amarelo' ? '#f7d869' : x === 'Azul' ? '#99ccff' : x === 'Laranja' ? '#e68a00' : x === 'Vermelho' ? '#dd0808' : '#8c8c8c',
            'cotaterra': values.cotaterra,
            'restricao': values.restricao,
            'nivel_restricao': values.nivel_restricao,
            'extravasor': values.extravasor,
            'cotaconcreto': values.cotaconcreto,
            'modificacaotvr': values.modificacaotvr,
            'area': Number(values.area),
            'altura': Number(values.altura),
            'volume': Number(values.volume),
            'namaxH': Number(values.namaxH),
            'naminH': Number(values.naminH),
            'projeto': Number(values.projeto),
            'comprimento': Number(values.comprimento),
        }
        api.put(`/usinas`, { update_usinasui })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current("Usina editada!", { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao editar usina!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <BasicInfo values={values} setValues={setValues} update={update} />
                <UploadPae values={values} setValues={setValues} />
                <Monitor values={values} setValues={setValues} />
                <Barragem values={values} setValues={setValues} update={update} />
                <CreatedBy values={values} setValues={setValues} />
            </DialogContent >
            <DialogActions>
                <Button
                    // disabled={disable}
                    onClick={() => { Update() }}
                >
                    Salvar
                </Button>
                <Button onClick={() => { props.setOpen(false) }}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
